import { useState } from "react";
import { Link, Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import { LogoApp } from "../common/LogoApp";
import { tr } from "../../i18n";

export function LoginPage() {
  const { login, isAuthenticated } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  // Andrea 2026-10-08: dopo il login si torna dove si voleva andare
  // (es. /accetta-invito dal link di cessione squadra)
  const location = useLocation();
  const from = (location.state as { from?: { pathname: string; search?: string } } | null)?.from;

  if (isAuthenticated) {
    return <Navigate to={from ? `${from.pathname}${from.search ?? ""}` : "/"} replace />;
  }

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      const detail = (err as { response?: { data?: { detail?: string } } }).response?.data?.detail;
      setError(detail ?? tr("Errore durante il login"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-bg text-fg flex flex-col items-center justify-center p-6 gap-4">
      <div className="bg-bg-card border border-primary/30 rounded-card shadow-hero p-8 max-w-md w-full">
        <LogoApp className="w-20 h-20 mx-auto mb-4" />
        <h1 className="font-display text-4xl text-accent text-center mb-2 tracking-wider">
          FantaSquad
        </h1>
        <p className="text-fg-muted text-center text-sm mb-6">{tr("Accedi al tuo club")}</p>

        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="block text-xs uppercase tracking-wider text-fg-muted mb-1">
              {tr("Email")}
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
              className="w-full px-3 py-2 bg-primary-deep border border-primary-soft rounded-lg text-fg focus:outline-none focus:ring-2 focus:ring-accent"
            />
          </div>
          <div>
            <label className="block text-xs uppercase tracking-wider text-fg-muted mb-1">
              {tr("Password")}
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
              className="w-full px-3 py-2 bg-primary-deep border border-primary-soft rounded-lg text-fg focus:outline-none focus:ring-2 focus:ring-accent"
            />
          </div>

          {error && (
            <div className="text-danger text-sm bg-danger/10 border border-danger/30 rounded p-3">
              ⚠️ {error}
            </div>
          )}

          <button type="submit" disabled={loading} className="btn-primary w-full">
            {loading ? tr("Login…") : tr("Accedi")}
          </button>

          <div className="text-xs text-fg-muted text-center mt-4 space-y-2">
            <p>
              <Link to="/forgot-password" className="hover:text-accent">
                {tr("Password dimenticata?")}
              </Link>
            </p>
            <p>
              {tr("Non hai ancora un account?")}{" "}
              <Link to="/register" className="hover:text-accent">
                {tr("Registrati")}
              </Link>
            </p>
          </div>
        </form>
      </div>
      {/* Andrea 2026-10-10: ritorno alla presentazione */}
      <Link to="/benvenuto" className="text-xs text-fg-muted hover:text-accent">
        {tr("← Scopri cos'è FantaSquad")}
      </Link>
    </div>
  );
}
